<script lang="ts">
    import { Store } from '../../../modules/infra/store.service'
    import { UsersRepository } from '../../../modules/usersApi/users/users.repository'
    import { UsersService } from '../../../modules/usersApi/users/users.service'
    import { get_current_component, onMount } from 'svelte/internal'
    import { Token } from '../../../modules/usersApi/token/token'
    import { createEventDispatcher } from 'svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Fa from 'svelte-fa'
    import { faCheck, faEnvelope, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
    import { navigateTo } from 'yrv'
    import type { UpdatePasswordDto } from '../../../modules/usersApi/auth/dto/update-password.dto'
    const dispatch = createEventDispatcher()

    const usersRep = new UsersRepository()
    let usersS = new UsersService(usersRep)

    const me = get_current_component()
    let step = 1
    let show = false
    let phoneOrEmail = ''
    let password = ''
    let passwordCheck = ''
    let smsCode = ''

    function validatePhoneEmail(): boolean {
        if (!phoneOrEmail) {
            window.error('Informe seu e-mail ou celular.')
            return false
        }
        if (phoneOrEmail.includes('@') && phoneOrEmail.length < 7) {
            window.error('Informe um e-mail ou celular válido.')
            return false
        }
        if (!phoneOrEmail.includes('@') && phoneOrEmail.length < 10) {
            window.error('Informe um e-mail ou celular válido.')
            return false
        }
        return true
    }

    async function evaluteLogin() {
        if (!validatePhoneEmail()) return
        if (password.length < 6) {
            window.error('Informe sua senha com no mínimo 6 dígitos.')
            return false
        }
        let phone
        let email
        if (phoneOrEmail.includes('@')) {
            email = phoneOrEmail
        } else {
            phone = phoneOrEmail
        }
        try {
            show = true
            await window.api.users.auth.loginByPassword({ phone, email, password })
            showSuccess()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function showLogin() {
        step = 1
    }

    function showSuccess() {
        step = 2
        finish()
    }

    function showRecovery() {
        step = 3
    }

    function showExpired() {
        step = 8
    }

    async function evaluateRecovery() {
        if (!validatePhoneEmail) return
        let phone
        let email
        if (phoneOrEmail.includes('@')) {
            email = phoneOrEmail
        } else {
            phone = phoneOrEmail
        }
        try {
            show = true
            if (email) {
                await window.api.users.auth.requestLoginByEmail({ email })
                step = 4
            } else {
                await window.api.users.auth.requestLoginBySMS({ phone })
                step = 5
            }
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function evaluateInputSMS() {
        try {
            show = true
            await window.api.users.auth.loginBySMS({ phone: phoneOrEmail, smsCode })
            step = 6
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    async function evaluateUpdatePassword() {
        try {
            if (password.length < 6) {
                window.error('Informe sua senha com no mínimo 6 dígitos.')
                return false
            }
            if (password !== passwordCheck) {
                window.error('A segunda senha não confere com a primeira.')
                return false
            }
            show = true
            const data: UpdatePasswordDto = {
                oldPassword: '',
                newPassword: password,
            }
            // utiliza o token da url para atualizar o password
            const url = new URL(window.self.location.href)
            // caso seja recuperação de senha por token haverá um token no parâmetro que deverá ser atualizado antes de salvar o password
            const token = url.searchParams.get('token')
            if (token) {
                await window.api.users.auth.refreshToken(token) // refresh token get a token from server and update locally (token received by link isn't persisted and haven't all token data object)
            }
            await window.api.users.auth.updatePassword(data)
            showSuccess()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function finish() {
        let cleanUrl = removeParam(self.location.href, 'renew')
        cleanUrl = removeParam(cleanUrl, 'token')
        cleanUrl = removeParam(cleanUrl, 'company')
        cleanUrl = removeParam(cleanUrl, 'alert')
        //me.dispatchEvent(new CustomEvent('success', {}))
        dispatch('success', {})
    }

    function removeParam(url, paramToRemove) {
        let rtn = url.split('?')[0]
        let param
        let params_arr = []
        let queryString = url.indexOf('?') !== -1 ? url.split('?')[1] : ''
        if (queryString !== '') {
            params_arr = queryString.split('&')
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split('=')[0]
                if (param === paramToRemove) {
                    params_arr.splice(i, 1)
                }
            }
            if (params_arr.length) rtn = rtn + '?' + params_arr.join('&')
        }
        return rtn
    }

    async function evaluatePostedToken() {
        const url = new URL(window.self.location.href)
        const token = url.searchParams.get('token')
        const companyId: string = url.searchParams.get('company')
        const alert = url.searchParams.get('alert') == '1' || url.searchParams.get('alert') == 'true'
        if (alert) {
            window.store.alert = true
        }
        if (token) {
            try {
                step = 9
                show = true
                // se está informando uma empresa então remove a atual pois será populado em seguida (remove pois o tempo de popular o app em outro ponto pode fazer uma chamada em store.company)
                if (companyId) {
                    window.store.company = null
                }
                const renewPassword = url.searchParams.get('renew') == '1' || url.searchParams.get('renew') == 'true'
                if (renewPassword) {
                    step = 6
                } else {
                    await window.api.users.auth.refreshToken(token) // refresh token get a token from server and update locally (token received by link isn't persisted and haven't all token data object)
                    window.store.user = await window.api.users.users.getOne(window.store.token.userId)
                    if (companyId) {
                        await window.api.users.companies.setCurrent(companyId)
                    }
                    showSuccess()
                }
            } catch (error) {
                window.log('setCompany failed', 'debug', { error, context: 'login-form.svelte' })
                // if user access first time, there is no infra information and an error fires.
                // then lets abort and wait infra.bootstrap to update the page.
                if (String(error).includes('Cannot read properties of null')) return
                step = 8
                window.error(error)
            } finally {
                show = false
            }
        }
    }

    async function evaluateLogout() {
        const url = new URL(window.self.location.href)
        const act = url.searchParams.get('act')
        if (act === 'logout') {
            console.log('act-logout')
            console.log('logout WRONG way')
            await window.api.users.auth.logout(false)
            location.href = '/login'
        }
    }

    function goSignUp() {
        navigateTo('/signup')
    }

    console.log('login-form 1', location.href)
    onMount(async () => {
        console.log('login-form 2', location.href)
        await evaluatePostedToken()
        await evaluateLogout()
    })
</script>

<div class="root">
    {#if step === 1}
        <h1>Entrar</h1>
        <p class="sub">Use o celular ou o e-mail cadastrado na sua conta.</p>
        <form on:submit|preventDefault={evaluteLogin}>
            <Zinput label="Celular ou e-mail" type="text" name="username" id="username" autocomplete="username" bind:value={phoneOrEmail} />
            <Zinput label="Senha" type="password" name="password" id="password" autocomplete="current-password" bind:value={password} />
            <!-- botão nativo para o Enter submeter o formulário; o Zbutton ao lado é o visível -->
            <button type="submit" class="submit-native" tabindex="-1" aria-hidden="true"></button>
            <Zbutton color="primary" label="Login" grow={true} growM={true} loading={show} on:click={evaluteLogin} />
        </form>
        <div class="links">
            <button class="link" on:click={showRecovery}>Esqueci minha senha</button>
            <!-- <button class="link" on:click={goSignUp}>Quero me cadastrar</button> -->
        </div>
    {/if}
    {#if step === 2}
        <div class="msg">
            <span class="msg-icon ok"><Fa icon={faCheck} /></span>
            <h1>Tudo certo</h1>
            <p class="sub">Login realizado. Abrindo o Zandu…</p>
        </div>
    {/if}
    {#if step === 3}
        <h1>Recuperar senha</h1>
        <p class="sub">Informe o celular e enviamos um código pelo WhatsApp. Com e-mail, enviamos um link.</p>
        <form on:submit|preventDefault={evaluateRecovery}>
            <Zinput label="Celular ou e-mail" type="text" autocomplete="username" bind:value={phoneOrEmail} />
            <button type="submit" class="submit-native" tabindex="-1" aria-hidden="true"></button>
            <Zbutton color="primary" label="Recuperar senha" grow={true} growM={true} loading={show} on:click={evaluateRecovery} />
        </form>
        <div class="links">
            <button class="link" on:click={showLogin}>Voltar para o login</button>
        </div>
    {/if}
    {#if step === 4}
        <div class="msg">
            <span class="msg-icon"><Fa icon={faEnvelope} /></span>
            <h1>Verifique seu e-mail</h1>
            <p class="sub">Se o e-mail informado for válido, enviamos um link para você criar uma senha nova.</p>
        </div>
        <Zbutton color="primary" label="Ok" grow={true} growM={true} on:click={finish} />
    {/if}
    {#if step === 5}
        <h1>Código do WhatsApp</h1>
        <p class="sub">Enviamos um código para o seu WhatsApp. Ele vale por poucos minutos.</p>
        <form on:submit|preventDefault={evaluateInputSMS}>
            <Zinput label="Código" type="text" maxlength={8} autocomplete="one-time-code" bind:value={smsCode} />
            <button type="submit" class="submit-native" tabindex="-1" aria-hidden="true"></button>
            <Zbutton color="primary" label="Confirmar" grow={true} growM={true} loading={show} on:click={evaluateInputSMS} />
        </form>
        <div class="links">
            <button class="link" on:click={showRecovery}>Enviar de novo</button>
        </div>
    {/if}
    {#if step === 6}
        <h1>Criar uma senha</h1>
        <p class="sub">A senha precisa ter no mínimo 6 caracteres.</p>
        <form on:submit|preventDefault={evaluateUpdatePassword}>
            <Zinput label="Nova senha" type="password" autocomplete="new-password" bind:value={password} />
            <Zinput label="Repita a senha" type="password" autocomplete="new-password" bind:value={passwordCheck} />
            <button type="submit" class="submit-native" tabindex="-1" aria-hidden="true"></button>
            <div class="tos">
                Ao criar uma senha você estará concordando com nossos <a target="_blank" href="/TOS.html">termos de uso</a>.
            </div>
            <Zbutton color="primary" label="Concordar e salvar senha" grow={true} growM={true} loading={show} on:click={evaluateUpdatePassword} />
        </form>
        <div class="links">
            <button class="link" on:click={showSuccess}>Agora não</button>
        </div>
    {/if}
    {#if step === 8}
        <div class="msg">
            <span class="msg-icon warn"><Fa icon={faTriangleExclamation} /></span>
            <h1>Link inválido</h1>
            <p class="sub">O link expirou ou não é válido. Faça o login para continuar.</p>
        </div>
        <Zbutton color="primary" label="Ok" grow={true} growM={true} on:click={showLogin} />
    {/if}
    {#if step === 9}
        <div class="msg">
            <h1>Aguarde…</h1>
            <p class="sub">Estamos abrindo sua conta.</p>
        </div>
    {/if}
    <LoadSpinner {show} />
</div>

<style>
    /* Esta tela fica sobre a ilustração colorida e é sempre escura, com tema claro ou escuro. Os
       campos do app são translúcidos de propósito (se adaptam ao que está atrás) — aqui isso os
       deixaria avermelhados, então as variáveis de campo voltam a valores opacos só neste bloco.
       Como variável CSS herda, isso vale para todo Zinput desenhado aqui dentro. */
    .root {
        --z-field-bg: #2b2b2b;
        --z-field-border: #ffffff26;
        --z-field-text: #eeeeee;
        --z-field-label: #a8a8a8;
        --z-field-solid-bg: #2b2b2b;

        max-width: 380px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        color: #f2f2f2;
    }

    h1 {
        font-size: 26px;
        font-weight: 600;
        margin: 0px;
    }
    .sub {
        margin: 6px 0px 20px;
        font-size: 14px;
        line-height: 1.35;
        color: #c7c7c7;
    }

    form {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    /* existe só para o Enter enviar o formulário — o botão visível é o Zbutton */
    .submit-native {
        display: none;
    }

    .links {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-top: 16px;
    }
    .link {
        border: 0px;
        background: none;
        padding: 0px;
        color: #cfe8dc;
        font-size: 14px;
        text-decoration: underline;
        cursor: pointer;
    }
    .link:hover {
        color: #ffffff;
    }

    /* telas de recado (sucesso, link expirado, e-mail enviado) */
    .msg {
        text-align: center;
        margin-bottom: 20px;
    }
    .msg .sub {
        margin-bottom: 0px;
    }
    .msg-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        margin-bottom: 12px;
        border-radius: 50%;
        background: #ffffff1a;
        font-size: 20px;
    }
    .msg-icon.ok {
        background: #157c53;
    }
    .msg-icon.warn {
        background: #b67503;
    }

    .tos {
        font-size: 13px;
        line-height: 1.35;
        color: #c7c7c7;
    }
    .tos a {
        color: #cfe8dc;
        text-decoration: underline;
    }
</style>
